import React from 'react'
import { Stack, Typography, Divider, Button } from '@mui/material'
import { AccountPreview, AccountPopoverFooter, SignOutButton } from '@toolpad/core/Account'
import { useSession } from '@toolpad/core/useSession'
import { PROFILE } from '../../_constants/routes'
import { ContactMailOutlined as ContactMail } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

const PopoverContent = () => {
  
  const session = useSession()
  const navigate = useNavigate()
  
  if (!session?.user) return <Typography>No user session available</Typography>
  else return (
    <Stack>
      <AccountPreview variant='expanded' />
      <Divider />
      <AccountPopoverFooter sx={{ justifyContent: 'space-around' }}>
        <Button
          variant='outlined'
          startIcon={<ContactMail />}
          onClick={() => navigate(PROFILE)}
          sx={{ textTransform: 'none', fontWeight: 'normal', fontSize: '.8125rem' }}
        >Profil</Button>
        <SignOutButton />
      </AccountPopoverFooter>
    </Stack>
  )
}

export default PopoverContent
